// extracted by mini-css-extract-plugin
export default {"unavailable":"News-unavailable_ytx"};